import { IMavenoidApiConfiguration } from '../models';

let MAVENOID_API_BASE_API_CONFIG: IMavenoidApiConfiguration = {
  scopes: [],
};

export const getMavenoidApiConfig = (): IMavenoidApiConfiguration => {
  return MAVENOID_API_BASE_API_CONFIG;
};

export const setMavenoidApiConfig = (config: IMavenoidApiConfiguration) => {
  MAVENOID_API_BASE_API_CONFIG = { ...config };
};
